import type { ProductsItem } from "@/partner/entities/products";
import type { MinPrice } from "../model/types";

/**
 * Минимальная цена продукта — минимум по значению value среди ВСЕХ окон
 * (periods) всех прайсов продукта (референс:
 * partner/utils/getMinPrice.js — без фильтрации по dateFrom, берётся
 * буквальный минимум по всем периодам). oldValue в результате — от того же
 * периода, на котором нашёлся минимум ("активного минимума").
 */
export function getMinPrice(
  product: Pick<ProductsItem, "prices">
): MinPrice | null {
  const periods = product.prices.flatMap((price) =>
    price.periods.map((period) => ({
      value: period.value,
      oldValue: period.oldValue ?? null,
      currency: price.currency,
    }))
  );

  if (periods.length === 0) {
    return null;
  }

  return periods.reduce((min, current) =>
    current.value < min.value ? current : min
  );
}
